export default {
  computed: {
    commerceItems() {
      return [
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.with_commerce'),
          value: 1,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.without_commerce'),
          value: 0,
        },
      ];
    },
  },
};
